export const BREAKPOINTS = {
  xlarge: "1280px",
  large: "1024px",
  medium: "768px",
  small: "480px",
};
